module.exports = __webpack_public_path__ + "static/media/lb.e33a49a9.svg";